var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 25,
    viewBox: "0 0 17 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9705 9.76548L0.185547 0.326477V24.3265L14.9645 14.8535C15.3947 14.5831 15.7494 14.2081 15.9954 13.7635C16.2414 13.3189 16.3708 12.8192 16.3714 12.3111C16.372 11.803 16.2438 11.303 15.9989 10.8579C15.7539 10.4127 15.4001 10.0369 14.9705 9.76548ZM13.8905 13.1605L2.19055 20.6605V3.98448L13.8975 11.4585C14.0419 11.5488 14.1608 11.6744 14.243 11.8235C14.3252 11.9726 14.368 12.1402 14.3673 12.3104C14.3666 12.4807 14.3224 12.6479 14.239 12.7963C14.1556 12.9447 14.0356 13.0694 13.8905 13.1585V13.1605Z",
    fill: "#666666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.10d58387383180e3acfc5215b1d50bce.svg";
export { ForwardRef as ReactComponent };